import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedin,
  FaMapMarkerAlt,
  FaCircle,
} from "react-icons/fa";
import "./CleanProfessional.css";

const CleanProfessionalTemplate = ({ resumeData }) => {
  if (!resumeData) return <div className="cp-loading">Loading...</div>;

  const {
    personal = {},
    education = [],
    experience = [],
    skills = { technical: [], soft: [], languages: [] },
    achievements = [],
    interests = [],
    certifications = [],
  } = resumeData;

  return (
    <div className="cp-a4-container">
      {/* HEADER SECTION */}
      <header className="cp-header">
        <div className="cp-header-content">
          <h1 className="cp-user-name">{personal.fullName || "YOUR NAME"}</h1>
          <p className="cp-user-title">{personal.title || "Target Role"}</p>

          <div className="cp-contact-bar">
            {personal.email && (
              <span>
                <FaEnvelope className="cp-icon" /> {personal.email}
              </span>
            )}
            {personal.phone && (
              <span>
                <FaPhoneAlt className="cp-icon" /> {personal.phone}
              </span>
            )}
            {personal.linkedin && (
              <span>
                <FaLinkedin className="cp-icon" /> LinkedIn
              </span>
            )}
            {personal.address && (
              <span>
                <FaMapMarkerAlt className="cp-icon" /> {personal.address}
              </span>
            )}
          </div>
        </div>
        {/* Background Pattern logic matching Image 3 */}
        <div className="cp-header-pattern"></div>
      </header>

      <div className="cp-main-layout">
        {/* LEFT COLUMN */}
        <div className="cp-col-left">
          {/* SUMMARY */}
          {personal.summary && (
            <section className="cp-section">
              <h3 className="cp-section-title">SUMMARY</h3>
              <p className="cp-text-content">{personal.summary}</p>
            </section>
          )}

          {/* EXPERIENCE */}
          {experience.length > 0 && (
            <section className="cp-section">
              <h3 className="cp-section-title">EXPERIENCE</h3>
              {experience.map((exp, idx) => (
                <div key={idx} className="cp-item-block">
                  <div className="cp-item-header">
                    <span className="cp-bold">{exp.title}</span>
                  </div>
                  <div className="cp-item-sub">
                    <span className="cp-blue-text">{exp.company}</span>
                    <span className="cp-light-text">
                      {exp.startDate} - {exp.current ? "Present" : exp.endDate}
                    </span>
                  </div>
                  <ul className="cp-bullets">
                    {exp.description?.split("\n").map((line, i) => (
                      <li key={i}>{line}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </section>
          )}

          {/* LANGUAGES */}
          {skills.languages?.length > 0 && (
            <section className="cp-section">
              <h3 className="cp-section-title">LANGUAGES</h3>
              <div className="cp-lang-grid">
                {skills.languages.map((lang, idx) => (
                  <div key={idx} className="cp-lang-item">
                    <span className="cp-bold">{lang}</span>
                    <div className="cp-lang-dots">
                      <FaCircle className="cp-dot active" />
                      <FaCircle className="cp-dot active" />
                      <FaCircle className="cp-dot active" />
                      <FaCircle className="cp-dot" />
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>

        {/* RIGHT COLUMN */}
        <div className="cp-col-right">
          {/* ACHIEVEMENTS */}
          {achievements.length > 0 && (
            <section className="cp-section">
              <h3 className="cp-section-title">KEY ACHIEVEMENTS</h3>
              {achievements.map((ach, idx) => (
                <div key={idx} className="cp-ach-item">
                  <p className="cp-bold">
                    {ach.split(":")[0] || "Achievement"}
                  </p>
                  <p className="cp-light-text cp-small">{ach}</p>
                </div>
              ))}
            </section>
          )}

          {/* SKILLS */}
          {skills.technical?.length > 0 && (
            <section className="cp-section">
              <h3 className="cp-section-title">SKILLS</h3>
              <div className="cp-skill-tags">
                {skills.technical.map((skill, idx) => (
                  <span key={idx} className="cp-tag">
                    {skill}
                  </span>
                ))}
              </div>
            </section>
          )}

          {/* EDUCATION */}
          {education.length > 0 && (
            <section className="cp-section">
              <h3 className="cp-section-title">EDUCATION</h3>
              {education.map((edu, idx) => (
                <div key={idx} className="cp-edu-item">
                  <p className="cp-bold">{edu.degree}</p>
                  <p className="cp-blue-text cp-small">{edu.institution}</p>
                  <p className="cp-light-text cp-small">{edu.year}</p>
                </div>
              ))}
            </section>
          )}
        </div>
      </div>
    </div>
  );
};

export default CleanProfessionalTemplate;
